import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-quiz',
  templateUrl: './main-quiz.component.html',
  styleUrls: ['./main-quiz.component.css']
})
export class MainQuizComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
